


export function inViewport(element) {
  if (!element) return false;
  if (1 !== element.nodeType) return false;

  const html = document.documentElement;
  const rect = element.getBoundingClientRect();

  return (
    !!rect &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.left <= html.clientWidth &&
    rect.top <= html.clientHeight
  );
}

export function positive(value) {
  return value.startsWith("-") ? value.substring(1) : value;
}

export function country(t, code) {
  if (!code) return "";
  return t(`country:${code}`, code);
}


export function arrayEquals(a, b) {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
}

export function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}


export function copyToClipboard(content) {
  navigator.clipboard.writeText(content);
}


function checkIfWebkit() {
  try {
    const ua = navigator.userAgent;
    return (/AppleWebKit/.test(ua) || /\b(iPad|iPhone|iPod)\b/.test(ua));
  } catch (err) {
    return false;
  }
};

export function calcUIDimensions() {
  try {
    let screenW = window.innerWidth;

    if (screenW > 1400) {
      document.body.style.setProperty("--log-width", "348px");
    } else {
      document.body.style.setProperty("--log-width", "240px");
    }


    const scrollDiv = document.createElement("div");
    scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  } catch (err) {
    document.body.style.setProperty("--scrollbar-width", "6px");
  }
}

export const isWebkit = checkIfWebkit();

export const doNothing = () => { };


export function formatText(sep, ...args) {
  return args.filter(t => t !== "" && t !== null && t !== undefined).join(sep);
}


export function sortByName(a, b) {
  const nameA = a.execution.driver?.name || '';
  const nameB = b.execution.driver?.name || '';

  if (nameA === '' && nameB === '') return 0;
  if (nameA === '') return 1;
  if (nameB === '') return -1;

  return nameA.localeCompare(nameB);
}

export function sortByETA(a, b) {
  const etaA = a?.execution?.estimatedArrival;
  const etaB = b?.execution?.estimatedArrival;

  const timeA = etaA ? new Date(etaA).getTime() : -Infinity;
  const timeB = etaB ? new Date(etaB).getTime() : -Infinity;

  // If timeA or timeB is not a valid date, new Date(...).getTime() returns NaN.
  // We'll ensure that by treating such cases as Infinity.
  const validTimeA = isNaN(timeA) ? -Infinity : timeA;
  const validTimeB = isNaN(timeB) ? -Infinity : timeB;

  return validTimeA - validTimeB;
}


export function getLocalStorageValue(key, defaultValue = "") {
  try {
    return localStorage.getItem(key) || defaultValue;
  } catch (err) {
    console.log(err);
    return defaultValue;
  }
}

export function setLocalStorageValue(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    console.log(err);
  }
}


export function truncate(text, maxLength = 32) {
  return text.length < maxLength ? text : text.substring(0, maxLength - 2) + "..";
}